
import axios from 'axios';
import { req ,getByobj,postobj,exportExcel } from './axiosFun';

/**
 * 字典数据
 **/
// 所有列表
export const getDictListByPage = (params) => { return getByobj("get", "/sysDict/listByPage", params) };
// 所有列表add
export const addDictList = (params) => { return req("post", "/sysDict/insert", params) };
// 所有列表修改
export const editDictList = (params) => { return req("post", "/sysDict/update", params) };
// 所有列表删除
export const delDictList = (params) => { return req("post", "/sysDict/deleteById", params) };

/*
 * 字典类型
*/
// 添加
export const addDictType = (params) => { return getByobj("post", "/sysDictType/insert", params) };
// 删除
export const delDictType = (params) => { return req("post", "/sysDictType/deleteById", params) };
// 修改
export const editDictType = (params) => { return req("post", "/sysDictType/update", params) };
// 查询列表
export const dictTypeList = (params) => { return getByobj("get", "/sysDictType/listByPage", params) };
// 查询类型集合
export const gatherOptions = (params) => { return req("get", "/sysDictType/getDictTypeList", params) };
// 根据字典类型id查询列表
export const getDictByTypeId = (id) => { return getByobj("get", "/sysDict/listBydictTypeId/"+id) };
// 分类列表
export const MachineConfigSave = (params) => { return req("post", "/MachineConfig/save", params) };
/*
 * 登录日志
*/
export const loginLog = (params) => { return getByobj("get", "/loginLog/listByPage", params) };
/*
 * 菜单管理
*/
// 新增
export const menuInsert = (params) => { return req("post", "/menu/insert", params) };
// 修改
export const menuUpdate = (params) => { return req("post", "/menu/update", params) };
// 删除
export const menuDelete = (params) => { return req("post", "/menu/deleteById", params) };
// 菜单树 role
export const ModuleTree = () => { return req("get", "/menu/getMenusTree") };
// 菜单树 all
export const AllModuleTree = () => { return req("get", "/menu/getMenusTree?flag=1") };
// 菜单List
export const ModuleList = () => { return req("get", "/menu/getMenuList") };
// 获取首页用户信息数据
export const getVipUserCount = () => { return getByobj("get", "/vipUser/getVipUserCount") };
// 支付配置信息-删除支付配置信息
export const MachineConfigDelete = (params) => { return axios.delete("/MachineConfig/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

// 团长管理
// 新增分佣配置 configureKey AHL_LEADER_INCOME_PERCENTAGE_CONFIG AHL_LEADER_YUNCANG_KIND_CONFIG
export const addConfigure = (params) => { return postobj("post", "/system/configure/add",params) };
// 查分佣配置
export const configureList = (params) => { return getByobj("get", "/system/configure/list",params) };

// 团长列表
export const leaderList = (params) => { return getByobj("get", "/leader/list",params) };
// 交易记录
export const recordsList = (params) => { return getByobj("get", "/leader/transactionRecords",params) };

// 新增团长
export const addLeader = (params) => { return postobj("post", "/leader/add",params) };
// 审批
export const apply = (params) => { return postobj("post", "/leader/update",params) };
// 下载导入模板
export const getTemlate = (params) => { return exportExcel("post", "/leader/importTemplate",params) };
// 团长导入
export const importLeader = (params) => { return postobj("post", "/leader/importData",params) };
// 团长导出
export const exportLeader = (params) => { return exportExcel("post", "/leader/export",params) };

// 团长禁用
export const disableLeader = (params) => { return postobj("post", "/leader/enableStatus",params) };
// 团员明细
export const listMember = (params) => { return getByobj("get", "/leader/listMember",params) };
// 上级团长查询
export const selectUpLeader = (params) => { return getByobj("get", "/leader/selectUpLeader",params) };


// 好物圈列表
export const leaderTeamList = (params) => { return getByobj("get", "/leader/leaderTeam/leaderTeamList",params) };
// 提现列表
export const withdrawalReviewList = (params) => { return getByobj("get", "/withdraw/listByPage",params) };
// 提现审批
export const withdrawalProcess = (params) => { return postobj("post", "/withdraw/process",params) };

// 下载商品导入模板
export const importTemplate = (params) => { return exportExcel("get", "/product/importTemplate",params) };
// 商品信息导出
export const exportProduct = (params) => { return exportExcel("get", "/product/export",params) };
// 订单信息导出
export const exportOrder = (params) => { return exportExcel("get", "/order/export",params) };
// appuser用户信息导出
export const exportAppUser = (params) => { return exportExcel("get", "/appUser/export",params) };

// 积分明细导出
export const exportIntegralFlow = (params) => { return exportExcel("get", "/app/vip/vipIntegralFlow/export",params) };



// WEBPACK FOOTER //
// ./src/api/system.js